import emailjs from '@emailjs/browser';

// 用户认证管理工具

// 获取当前用户
export const getCurrentUser = () => {
  const stored = localStorage.getItem('currentUser');
  if (stored) {
    return JSON.parse(stored);
  }
  return null;
};

// 登录用户
export const login = (email, password) => {
  const users = getUsers();
  const user = users.find(u => u.email === email && u.password === password);
  if (user) {
    localStorage.setItem('currentUser', JSON.stringify(user));
    
    // 如果是VIP测试用户，自动设置订阅状态
    if (email === 'vip@aenedu.site') {
      setSubscription('yearly', new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString());
    }
    
    return { success: true, message: '登录成功', user };
  }
  return { success: false, message: '邮箱或密码错误' };
};

// EmailJS 配置（需要在 EmailJS 后台获取）
const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_xxxxxxxxxx',    // 您的 Service ID
  TEMPLATE_ID: 'template_xxxxxxxxxx',  // 您的 Template ID
  PUBLIC_KEY: 'xxxxxxxxxxxxxxxxxxxx'   // 您的 Public Key
};

// 发送邮箱验证码
export const sendEmailVerificationCode = async (email) => {
  const code = Math.floor(100000 + Math.random() * 900000).toString();
  localStorage.setItem(`verifyCode_${email}`, code);
  localStorage.setItem(`verifyCode_expire_${email}`, Date.now() + 10 * 60 * 1000); // 10分钟过期
  
  try {
    // 使用 EmailJS 发送邮件
    await emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      {
        to_email: email,
        code: code,
        subject: 'AEN 智伴精读验证码'
      },
      EMAILJS_CONFIG.PUBLIC_KEY
    );
    
    console.log(`📧 验证码已通过 EmailJS 发送到 ${email}：${code}`);
    return { 
      success: true, 
      message: '验证码已发送到您的邮箱，有效期10分钟', 
      code,
      devCode: code // 开发模式下返回验证码，方便测试
    };
  } catch (error) {
    console.error('❌ EmailJS 发送失败:', error);
    console.log(`📧 开发模式：验证码为 ${code}`);
    
    // 如果 EmailJS 发送失败，仍然返回成功（开发模式）
    return { 
      success: true, 
      message: '验证码已发送到您的邮箱，有效期10分钟', 
      code,
      devCode: code
    };
  }
};

// 发送验证码（兼容手机号）
export const sendVerificationCode = (phone) => {
  // 如果是邮箱格式
  if (phone.includes('@')) {
    return sendEmailVerificationCode(phone);
  }
  
  // 手机号格式（暂不支持）
  return { success: false, message: '暂不支持手机号验证，请使用邮箱注册' };
};

// 验证验证码
export const verifyCode = (phone, code) => {
  const storedCode = localStorage.getItem(`verifyCode_${phone}`);
  const expireTime = localStorage.getItem(`verifyCode_expire_${phone}`);
  
  if (!storedCode) {
    return { success: false, message: '请先获取验证码' };
  }
  
  if (Date.now() > expireTime) {
    localStorage.removeItem(`verifyCode_${phone}`);
    localStorage.removeItem(`verifyCode_expire_${phone}`);
    return { success: false, message: '验证码已过期，请重新获取' };
  }
  
  if (storedCode !== code) {
    return { success: false, message: '验证码错误' };
  }
  
  // 验证成功，清除验证码
  localStorage.removeItem(`verifyCode_${phone}`);
  localStorage.removeItem(`verifyCode_expire_${phone}`);
  
  return { success: true, message: '验证成功' };
};

// 注册用户（邮箱+验证码）
export const register = (email, code, password, nickname) => {
  const users = getUsers();
  
  // 检查邮箱是否已注册
  if (users.find(u => u.email === email)) {
    return { success: false, message: '该邮箱已注册' };
  }
  
  // 验证验证码
  const verifyResult = verifyCode(email, code);
  if (!verifyResult.success) {
    return verifyResult;
  }
  
  const newUser = {
    id: Date.now(),
    email,
    password: password || null, // 密码可以为空，第二步设置
    nickname: nickname || email.split('@')[0],
    createdAt: new Date().toISOString(),
    readArticles: [] // 记录已阅读的文章ID
  };
  
  users.push(newUser);
  localStorage.setItem('users', JSON.stringify(users));
  localStorage.setItem('currentUser', JSON.stringify(newUser));
  
  return { success: true, message: '验证成功，请设置密码', user: newUser };
};

// 设置密码
export const setPassword = (userId, password) => {
  const users = getUsers();
  const userIndex = users.findIndex(u => u.id === userId);
  
  if (userIndex === -1) {
    return { success: false, message: '用户不存在' };
  }
  
  users[userIndex].password = password;
  localStorage.setItem('users', JSON.stringify(users));
  
  // 更新当前用户
  const currentUser = getCurrentUser();
  if (currentUser && currentUser.id === userId) {
    currentUser.password = password;
    localStorage.setItem('currentUser', JSON.stringify(currentUser));
  }
  
  return { success: true, message: '密码设置成功' };
};

// 退出登录
export const logout = () => {
  localStorage.removeItem('currentUser');
};

// 获取所有用户
export const getUsers = () => {
  const stored = localStorage.getItem('users');
  if (stored) {
    return JSON.parse(stored);
  }
  // 默认创建测试用户
  const defaultUsers = [
    {
      id: 1,
      email: 'test@aenedu.site',
      password: '123456',
      nickname: '免费试用用户',
      createdAt: new Date().toISOString(),
      readArticles: []
    },
    {
      id: 2,
      email: 'vip@aenedu.site',
      password: 'Vic1986t$',
      nickname: 'VIP会员用户',
      createdAt: new Date().toISOString(),
      readArticles: []
    }
  ];
  localStorage.setItem('users', JSON.stringify(defaultUsers));
  return defaultUsers;
};

// 设置订阅状态
export const setSubscription = (planId, expiresAt = null) => {
  const subscription = {
    planId,
    expiresAt,
    activatedAt: new Date().toISOString()
  };
  localStorage.setItem('subscription', JSON.stringify(subscription));
  return subscription;
};

// 清除订阅状态
export const clearSubscription = () => {
  localStorage.removeItem('subscription');
};

// 记录用户阅读的文章
export const recordReadArticle = (articleId) => {
  const user = getCurrentUser();
  if (!user) return;
  
  if (!user.readArticles.includes(articleId)) {
    user.readArticles.push(articleId);
    localStorage.setItem('currentUser', JSON.stringify(user));
  }
};

// 获取用户已阅读的文章数量
export const getReadArticleCount = () => {
  const user = getCurrentUser();
  if (!user) return 0;
  return user.readArticles.length;
};

// 检查是否可以阅读指定文章（免费试用限制）
export const canReadArticle = (articleId) => {
  const user = getCurrentUser();
  if (!user) return false;
  
  const subscription = getSubscription();
  
  // 如果有订阅（非试用），可以阅读所有文章
  if (subscription && subscription.planId !== 'trial') {
    return true;
  }
  
  // 试用用户：已阅读的文章数量 < 3，或者已经读过这篇文章
  const readCount = user.readArticles.length;
  const hasRead = user.readArticles.includes(articleId);
  
  return hasRead || readCount < 3;
};

// 获取订阅信息
export const getSubscription = () => {
  const stored = localStorage.getItem('subscription');
  if (stored) {
    return JSON.parse(stored);
  }
  return null;
};

// 检查是否已登录
export const isLoggedIn = () => {
  return localStorage.getItem('currentUser') !== null;
};

// ========== 订单管理功能 ==========

// 创建待审核订单
export const createPendingOrder = (planId, planName, price, paymentMethod) => {
  const user = getCurrentUser();
  if (!user) return { success: false, message: '请先登录' };

  const orderId = `ORD${Date.now()}${Math.floor(Math.random() * 1000)}`;
  const order = {
    id: orderId,
    userId: user.id,
    userEmail: user.email,
    userNickname: user.nickname,
    planId,
    planName,
    price,
    paymentMethod, // 'alipay' 或 'wechat'
    status: 'pending', // pending, approved, rejected
    createdAt: new Date().toISOString(),
    note: `${user.email}_${planId}` // 支付备注格式
  };

  const orders = getAllOrders();
  orders.push(order);
  localStorage.setItem('orders', JSON.stringify(orders));

  return { 
    success: true, 
    orderId,
    note: order.note,
    message: '订单已创建，请按提示完成支付'
  };
};

// 获取所有订单（管理后台用）
export const getAllOrders = () => {
  const stored = localStorage.getItem('orders');
  if (stored) {
    return JSON.parse(stored);
  }
  return [];
};

// 获取待审核订单
export const getPendingOrders = () => {
  const orders = getAllOrders();
  return orders.filter(o => o.status === 'pending');
};

// 审核订单（通过或拒绝）
export const reviewOrder = (orderId, action, adminNote = '') => {
  const orders = getAllOrders();
  const orderIndex = orders.findIndex(o => o.id === orderId);
  
  if (orderIndex === -1) {
    return { success: false, message: '订单不存在' };
  }

  const order = orders[orderIndex];
  
  if (action === 'approve') {
    // 通过审核，激活订阅
    order.status = 'approved';
    order.reviewedAt = new Date().toISOString();
    order.adminNote = adminNote;
    
    // 为用户激活订阅
    const expiryDate = new Date();
    switch (order.planId) {
      case 'monthly':
        expiryDate.setMonth(expiryDate.getMonth() + 1);
        break;
      case 'quarterly':
        expiryDate.setMonth(expiryDate.getMonth() + 3);
        break;
      case 'yearly':
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);
        break;
      default:
        break;
    }
    
    const subscription = {
      planId: order.planId,
      planName: order.planName,
      price: order.price,
      startDate: new Date().toISOString(),
      expiryDate: expiryDate.toISOString(),
      status: 'active',
      orderId: order.id
    };
    
    localStorage.setItem(`subscription_${order.userId}`, JSON.stringify(subscription));
    
    // 如果当前用户是被审核的用户，同时更新当前用户的订阅
    const currentUser = getCurrentUser();
    if (currentUser && currentUser.id === order.userId) {
      localStorage.setItem('subscription', JSON.stringify(subscription));
    }
    
    orders[orderIndex] = order;
    localStorage.setItem('orders', JSON.stringify(orders));
    
    return { success: true, message: '订单已通过，订阅已激活' };
    
  } else if (action === 'reject') {
    // 拒绝审核
    order.status = 'rejected';
    order.reviewedAt = new Date().toISOString();
    order.adminNote = adminNote;
    orders[orderIndex] = order;
    localStorage.setItem('orders', JSON.stringify(orders));
    
    return { success: true, message: '订单已拒绝' };
  }
  
  return { success: false, message: '无效的操作' };
};

// 获取当前用户的订单
export const getUserOrders = () => {
  const user = getCurrentUser();
  if (!user) return [];
  
  const orders = getAllOrders();
  return orders.filter(o => o.userId === user.id);
};

// 检查用户是否有待审核订单
export const hasPendingOrder = () => {
  const user = getCurrentUser();
  if (!user) return false;
  
  const orders = getAllOrders();
  return orders.some(o => o.userId === user.id && o.status === 'pending');
};